import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets.app/images/finished-demo.gif'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)

import EmptyListingBlock from '@/app/components/listing/EmptyListingBlock.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'NoFinishedDocsBlock',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(EmptyListingBlock, { title: "Finished" }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _hoisted_1
    ]),
    _: 3
  }))
}
}

})